// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hu-0";